import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Portal,
  VStack,
  HStack,
  PopoverHeader,
  Text,
  Icon,
} from '@chakra-ui/react';
import { MdFilterList } from 'react-icons/md';
import { RiSaveFill } from 'react-icons/ri';

interface MenuProps {
  headers: {
    label: string;
    key: string;
    width: string;
    isVisible: boolean;
  }[];
  onFilter: (updatedHeaders: {
    label: string;
    key: string;
    width: string;
    isVisible: boolean;
  }[]) => void;
  children?: React.ReactNode;
}

function Menu({ headers, onFilter, children }: MenuProps) {
  const [localHeaders, setLocalHeaders] = useState(headers);

  const handleCheckboxChange = (key: string, isChecked: boolean) => {
    setLocalHeaders((prev) =>
      prev.map((header) =>
        header.key === key ? { ...header, isVisible: isChecked } : header
      )
    );
  };

  const applyFilters = () => {
    onFilter(localHeaders);
  };

  return (
    <Popover placement="auto-start" returnFocusOnClose>
      <PopoverTrigger>
        <Box textAlign="center" alignItems={'center'} display={'flex'} cursor="pointer">
          {children || (
            <HStack>
              <Icon boxSize={6} as={MdFilterList} />
              <Text>Selecionar Colunas</Text>
            </HStack>
          )}
        </Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent maxW={'max-content'} borderRadius="xl" shadow={'lg'} borderColor={"#117baa"}>
          <PopoverCloseButton size={'md'} _hover={{
            bg: 'red.300'
          }} color="white" rounded={'full'} bg={'red.500'} right={6} top={3} border={'2px solid white'} />
          <PopoverBody p={0} display={'flex'} maxW={'max-content'}>
            <Box overflowY="auto" p={4}>
              <VStack align="stretch" spacing={3}>
                {localHeaders.map((header, index) => (
                  <Checkbox
                    key={`menu-header-${index}-${header.key}`}
                    isChecked={header.isVisible}
                    borderColor={"#0F4F6D"}
                    color={'#0F4F6D'}
                    fontWeight={'bold'}
                    size={'sm'}
                    onChange={(e) => handleCheckboxChange(header.key, e.target.checked)}
                  >
                    <p>
                      {header.label}
                    </p>
                  </Checkbox>
                ))}
              </VStack>
            </Box>
            <HStack justify="flex-end" position={'absolute'} right={4} bottom={3}>
              <Button size="sm" bg={'#117baa'} width={'48px'} height={'48px'} p={1} border={'2px solid white'} rounded={'full'} onClick={applyFilters}>
                <RiSaveFill color='white' size={22} />
              </Button>
            </HStack>
            <Box bg={'#117BAA'} flex={1} w={'40px'} roundedBottomEnd={'xl'} roundedTopEnd={'xl'} p={1} />
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}

export default Menu;
